import { render, staticRenderFns } from "./FestivalCollection.vue?vue&type=template&id=2ee107a9&scoped=true"
import script from "./FestivalCollection.vue?vue&type=script&lang=js"
export * from "./FestivalCollection.vue?vue&type=script&lang=js"
import style0 from "./FestivalCollection.vue?vue&type=style&index=0&id=2ee107a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee107a9",
  null
  
)

export default component.exports